import axiosServer from '../../configs/axiosServer'
import crypto from '../../functions/crypto'
import router from '../../router/index.js'
import { showErrorAlert } from '@/functions/showErrorAlert'
import { getResponseStatus } from '@/functions/getResponseStatus'

const cookiesDomain = process.env.VUE_APP_COOKIES_DOMAIN

/* global $cookies */
/* eslint no-undef: "error" */
const storage = {
  namespaced: true,
  state: {
    accessToken: '',
    name: '',
    email: '',
    avatar: '',
    profession: '',
    userId: '',
    username: ''
  },
  mutations: {
    SET_ACCESS_TOKEN (state, payload) {
      state.accessToken = payload
    },
    SET_NAME (state, payload) {
      state.name = payload
    },
    SET_EMAIL (state, payload) {
      state.email = payload
    },
    SET_AVATAR (state, payload) {
      state.avatar = payload
    },
    SET_PROFESSION (state, payload) {
      state.profession = payload
    },
    SET_USER_ID (state, payload) {
      state.userId = payload
    },
    SET_USERNAME (state, payload) {
      state.username = payload
    }
  },
  actions: {
    loginSetStorage ({ state, commit }, payload) {
      commit('SET_ACCESS_TOKEN', payload.token.token)
      commit('SET_NAME', payload.data.name)
      commit('SET_AVATAR', payload.data.avatar)
      commit('SET_PROFESSION', payload.data.profession_name)
      commit('SET_USER_ID', payload.data.id)
      commit('SET_EMAIL', payload.data.email)
      commit('SET_USERNAME', payload.data.username)

      // remove admin and admin-type
      $cookies.remove('admin-type', '', cookiesDomain)
      $cookies.remove('admin', '', cookiesDomain)
      $cookies.remove('finance', '', cookiesDomain)

      const secure = location.hostname !== 'localhost'
      $cookies.set('access-token', crypto.encrypt(state.accessToken), '', '/', cookiesDomain, secure)
      $cookies.set('auth._token.cookie', crypto.encrypt(state.accessToken), '', '/', cookiesDomain, secure)
      $cookies.set('auth._token.local1', crypto.encrypt(state.accessToken), '', '/', cookiesDomain, secure)
      $cookies.set('name', crypto.encrypt(state.name), '', '/', cookiesDomain, secure)
      $cookies.set('avatar', crypto.encrypt(state.avatar), '', '/', cookiesDomain, secure)
      $cookies.set('profession', crypto.encrypt(state.profession), '', '/', cookiesDomain, secure)
      $cookies.set('user-id', crypto.encrypt(state.userId), '', '/', cookiesDomain, secure)
      $cookies.set('username', crypto.encrypt(state.username), '', '/', cookiesDomain, secure)
      $cookies.set('year-level', crypto.md5Encrypt(payload.data.year_level_name), '', '/', cookiesDomain, secure)
      $cookies.set('profession-user', crypto.md5Encrypt(payload.data.profession_name), '', '/', cookiesDomain, secure)
      $cookies.set('email', crypto.encrypt(payload.data.email), '', '/', cookiesDomain, secure)
      $cookies.set('province', crypto.encrypt(payload.data.province_id), '', '/', cookiesDomain, secure)
      $cookies.set('district', crypto.encrypt(payload.data.district_id), '', '/', cookiesDomain, secure)
    },
    setStorageApp ({ commit }) {
      const isAccessedFromKariermuB2bApp = window.atob($cookies.get('source-access')) === 'kariermu-b2b'

      let dataStore

      if (isAccessedFromKariermuB2bApp) {
        dataStore = {
          token: window.atob($cookies.get('access-token')),
          name: window.atob($cookies.get('name')),
          avatar: window.atob($cookies.get('avatar')),
          profession: window.atob($cookies.get('profession')),
          userId: Number(window.atob($cookies.get('user-id'))),
          username: window.atob($cookies.get('username')),
          email: window.atob($cookies.get('email'))
        }
      } else {
        dataStore = {
          token: crypto.decrypt($cookies.get('access-token')),
          name: crypto.decrypt($cookies.get('name')),
          avatar: crypto.decrypt($cookies.get('avatar')),
          profession: crypto.decrypt($cookies.get('profession')),
          userId: crypto.decrypt($cookies.get('user-id')),
          username: crypto.decrypt($cookies.get('username')),
          email: crypto.decrypt($cookies.get('email'))
        }
      }

      commit('SET_ACCESS_TOKEN', dataStore.token)
      commit('SET_NAME', dataStore.name)
      commit('SET_EMAIL', dataStore.email)
      commit('SET_AVATAR', dataStore.avatar)
      commit('SET_PROFESSION', dataStore.profession)
      commit('SET_USER_ID', dataStore.userId)
      commit('SET_USERNAME', dataStore.username)
    },
    async logoutRemoveStorage ({ rootState, commit, dispatch }) {
      commit('SET_ACCESS_TOKEN', '')
      commit('SET_NAME', '')
      commit('SET_EMAIL', '')
      commit('SET_AVATAR', '')
      commit('SET_PROFESSION', '')
      commit('SET_USER_ID', '')
      commit('SET_USERNAME', '')
      commit('user/CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION', false, { root: true })
      await dispatch('clearSessionToken')
      await $cookies.remove('access-token', '', cookiesDomain)
      await $cookies.remove('auth._token.cookie', '', cookiesDomain)
      await $cookies.remove('auth._token.local1', '', cookiesDomain)
      await $cookies.remove('auth._token_expiration.local1', '', cookiesDomain)
      await $cookies.remove('auth._token.local2', '', cookiesDomain)
      await $cookies.remove('auth._token_expiration.local2', '', cookiesDomain)
      await $cookies.remove('auth.strategy', '', cookiesDomain)
      await $cookies.remove('name', '', cookiesDomain)
      await $cookies.remove('avatar', '', cookiesDomain)
      await $cookies.remove('profession', '', cookiesDomain)
      await $cookies.remove('user-id', '', cookiesDomain)
      await $cookies.remove('username', '', cookiesDomain)
      await $cookies.remove('year-level', '', cookiesDomain)
      await $cookies.remove('profession-user', '', cookiesDomain)
      await $cookies.remove('email', '', cookiesDomain)
      await $cookies.remove('province', '', cookiesDomain)
      await $cookies.remove('district', '', cookiesDomain)
      await $cookies.remove('username', '', cookiesDomain)
    },
    async clearSessionToken () {
      try {
        await axiosServer({
          url: 'user/logout/',
          method: 'POST',
          headers: {
            Authorization: crypto.decrypt($cookies.get('access-token'))
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async checkToken ({ dispatch, commit }, payload) {
      let data, errorPath
      if (payload && typeof payload === 'object') {
        if (payload.status) {
          // Case 1: payload is the data object itself
          data = payload
          errorPath = payload.errorPath || 'ERR3334'
        } else if (payload.data) {
          // Case 2: payload has a data property
          data = payload.data
          errorPath = payload.errorPath || 'ERR3334'
        }
      }

      const status = data?.status || getResponseStatus(data) // double check if data.status is undefined

      if (status === 401) {
        await dispatch('logoutRemoveStorage')
        commit('user/CHANGE_IS_LOGIN', false, { root: true })
        commit('user/SET_IS_CIKAL', false, { root: true })
        router.push('/')
      } else if ([400, 500, 503].includes(status) || ![200].includes(status)) {
        showErrorAlert(data, null, null, errorPath)
      }
    }
  }
}

export default storage
